/* LumiArt™ — interakcje sekcji lumiart-*: koszyk, warianty, galeria, slidery, zakładki, wideo, animacje.
   Ładowany przez każdą sekcję; zabezpieczony, żeby uruchomić się tylko raz.
   Horizon przewija stronę w .page-wrapper, dlatego przewijanie robimy przez scrollIntoView. */
(function () {
  if (window.__laLoaded) return;
  window.__laLoaded = true;

  var docEl = document.documentElement;
  docEl.classList.add('la-js');
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---------- kwoty ---------- */
  function withDelimiters(cents, precision, thousands, decimal) {
    if (cents == null || isNaN(cents)) return '0';
    var parts = (cents / 100).toFixed(precision).split('.');
    var whole = parts[0];
    var out = '';
    while (whole.length > 3) {
      out = thousands + whole.slice(-3) + out;
      whole = whole.slice(0, -3);
    }
    out = whole + out;
    return parts[1] ? out + decimal + parts[1] : out;
  }
  function money(cents, format) {
    var fmt = (format || '{{amount_with_comma_separator}} zł').replace(/<[^>]*>/g, '');
    var start = fmt.indexOf('{{');
    var end = fmt.indexOf('}}');
    if (start < 0 || end < start) return withDelimiters(cents, 2, ' ', ',') + ' zł';
    var value;
    switch (fmt.slice(start + 2, end).trim()) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return fmt.slice(0, start) + value + fmt.slice(end + 2);
  }

  /* ---------- koszyk ---------- */
  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function addToCart(variantId, quantity, toCheckout) {
    var actions = window.Shopify && window.Shopify.actions;
    if (!toCheckout && actions && typeof actions.updateCart === 'function') {
      return Promise.resolve(
        actions.updateCart({ lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: quantity }] }, { context: 'product' })
      ).then(function (res) {
        if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
        if (typeof actions.openCart === 'function') {
          return Promise.resolve(actions.openCart()).catch(function () {}).then(function () { return res; });
        }
        return res;
      });
    }
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', quantity);
    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      body: body,
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) throw new Error(res.data.description || res.data.message || 'Błąd koszyka');
        window.location.href = rootUrl() + (toCheckout ? 'checkout' : 'cart');
        return res.data;
      });
  }

  /* ---------- karta produktu ---------- */
  function initBuybox(box) {
    if (box.__la) return;
    box.__la = true;

    var dataEl = box.querySelector('[data-la-variants]');
    var form = box.querySelector('form[data-la-form]');
    if (!dataEl || !form) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent || '[]'); } catch (err) { return; }

    var fmt = box.getAttribute('data-money-format');
    var optionCount = parseInt(box.getAttribute('data-options') || '0', 10);
    var freeShip = parseInt(box.getAttribute('data-free-ship') || '0', 10);
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('[data-la-qty]');
    var buttons = Array.prototype.slice.call(box.querySelectorAll('[data-la-atc]'));
    var errorEl = box.querySelector('[data-la-error]');
    var current = null;

    function t(name, fallback) { return box.getAttribute('data-t-' + name) || fallback; }
    function each(selector, fn) { Array.prototype.forEach.call(box.querySelectorAll(selector), fn); }
    function qty() { return Math.min(99, Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1)); }
    function selected() {
      var out = [];
      for (var i = 0; i < optionCount; i++) {
        var checked = box.querySelector('input[data-la-option="' + i + '"]:checked');
        out.push(checked ? checked.value : null);
      }
      return out;
    }
    function find(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var k = 0; k < sel.length; k++) if (v.options[k] !== sel[k]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function fill(tpl, v) {
      return (tpl || '')
        .replace('[p]', Math.round(((v.compare - v.price) * 100) / v.compare))
        .replace('[a]', money(v.compare - v.price, fmt));
    }
    function updateShipping(v) {
      if (!freeShip) return;
      var total = v ? v.price * qty() : 0;
      var left = Math.max(0, freeShip - total);
      var pct = Math.min(100, Math.round((total * 100) / freeShip));
      each('[data-la-ship-bar]', function (el) { el.style.setProperty('--p', pct + '%'); });
      each('[data-la-ship-msg]', function (el) {
        if (left > 0) {
          var parts = (el.getAttribute('data-tpl-left') || '').split('[a]');
          el.textContent = '';
          el.appendChild(document.createTextNode(parts[0] || ''));
          var strong = document.createElement('strong');
          strong.textContent = money(left, fmt);
          el.appendChild(strong);
          el.appendChild(document.createTextNode(parts.slice(1).join('')));
        } else {
          el.textContent = el.getAttribute('data-tpl-free') || '';
        }
      });
    }

    function update(fromUser) {
      var sel = selected();
      var v = optionCount ? find(sel) : variants[0];
      current = v;

      each('[data-la-choice]', function (label) {
        var input = label.querySelector('input');
        if (!input) return;
        label.classList.toggle('is-selected', input.checked);
        var test = sel.slice();
        test[+input.getAttribute('data-la-option')] = input.value;
        var match = find(test);
        label.classList.toggle('is-unavailable', !match || !match.available);
      });
      sel.forEach(function (val, i) {
        each('[data-la-selected="' + i + '"]', function (el) { el.textContent = val || ''; });
      });

      if (!v) {
        buttons.forEach(function (b) {
          b.disabled = true;
          var l = b.querySelector('[data-la-label]');
          if (l) l.textContent = t('unavailable', 'Niedostępne');
          var p = b.querySelector('[data-la-btn-price]');
          if (p) p.textContent = '';
        });
        return;
      }

      if (idInput) idInput.value = v.id;
      var onSale = v.compare > v.price;
      each('[data-la-price]', function (el) { el.textContent = money(v.price, fmt); });
      each('[data-la-compare]', function (el) {
        el.hidden = !onSale;
        if (onSale) el.textContent = money(v.compare, fmt);
      });
      each('[data-la-save]', function (el) {
        el.hidden = !onSale;
        if (onSale) el.textContent = fill(el.getAttribute('data-tpl'), v);
      });
      each('[data-la-omnibus]', function (el) {
        el.hidden = !onSale;
        var val = el.querySelector('[data-la-omnibus-value]');
        if (val) val.textContent = money(v.lowest || v.price, fmt);
      });
      each('[data-la-stock]', function (el) {
        el.classList.toggle('is-out', !v.available);
        var s = el.querySelector('[data-la-stock-text]');
        if (s) s.textContent = v.available ? t('instock', 'Dostępny') : t('soldout', 'Wyprzedane');
      });
      buttons.forEach(function (b) {
        b.disabled = !v.available;
        var l = b.querySelector('[data-la-label]');
        if (l) l.textContent = v.available ? b.getAttribute('data-t-add') : t('soldout', 'Wyprzedane');
        var p = b.querySelector('[data-la-btn-price]');
        if (p) p.textContent = v.available ? '· ' + money(v.price * qty(), fmt) : '';
      });
      each('[data-la-variant-title]', function (el) { el.textContent = v.title; });
      updateShipping(v);

      if (fromUser) {
        if (v.media) box.dispatchEvent(new CustomEvent('la:media', { detail: { id: v.media } }));
        if (box.getAttribute('data-update-url') === 'true' && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(window.history.state, '', url.toString());
        }
      }
    }

    function busy(on) {
      box.classList.toggle('is-busy', on);
      buttons.forEach(function (b) {
        b.classList.toggle('is-loading', on);
        if (on) b.setAttribute('aria-busy', 'true');
        else b.removeAttribute('aria-busy');
      });
    }
    function flashAdded() {
      buttons.forEach(function (b) {
        if (b.hasAttribute('data-la-buynow')) return;
        var l = b.querySelector('[data-la-label]');
        if (!l) return;
        l.textContent = t('added', 'Dodano do koszyka ✓');
        clearTimeout(b.__laTimer);
        b.__laTimer = setTimeout(function () { update(false); }, 2000);
      });
    }

    box.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('input[data-la-option]')) update(true);
    });
    each('[data-la-step]', function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        qtyInput.value = Math.min(99, Math.max(1, qty() + parseInt(btn.getAttribute('data-la-step'), 10)));
        update(false);
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = qty(); update(false); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!current || !current.available || box.classList.contains('is-busy')) return;
      var toCheckout = !!(e.submitter && e.submitter.hasAttribute('data-la-buynow'));
      if (errorEl) errorEl.hidden = true;
      busy(true);
      addToCart(current.id, qty(), toCheckout)
        .then(function () { if (!toCheckout) flashAdded(); })
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = (err && err.message) || t('error', 'Nie udało się dodać do koszyka.');
            errorEl.hidden = false;
          }
        })
        .then(function () { busy(false); });
    });

    /* pasek na dole: pojawia się, gdy główny przycisk zniknie z ekranu */
    var sticky = box.querySelector('[data-la-sticky]');
    var mainBtn = form.querySelector('[data-la-atc]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(mainBtn);
      var stickyBtn = sticky.querySelector('[data-la-sticky-btn]');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(mainBtn);
          else mainBtn.click();
        });
      }
    }

    /* opcjonalny licznik do godziny wysyłki (pn–pt) */
    var timer = box.querySelector('[data-la-timer]');
    if (timer) {
      var timerWrap = box.querySelector('[data-la-timer-wrap]');
      var cutoff = parseInt(timer.getAttribute('data-cutoff') || '14', 10);
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var now = new Date();
        var day = now.getDay();
        var end = new Date(now.getTime());
        end.setHours(cutoff, 0, 0, 0);
        var active = day >= 1 && day <= 5 && now < end;
        if (timerWrap) timerWrap.hidden = !active;
        if (!active) return;
        var s = Math.floor((end - now) / 1000);
        timer.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      };
      tick();
      setInterval(tick, 1000);
    }

    box.__laSelect = function (variantId) {
      var v = null;
      for (var i = 0; i < variants.length; i++) if (variants[i].id === variantId) { v = variants[i]; break; }
      if (!v) return false;
      v.options.forEach(function (val, idx) {
        each('input[data-la-option="' + idx + '"]', function (inp) { if (inp.value === val) inp.checked = true; });
      });
      update(true);
      return true;
    };

    update(false);
  }

  /* ---------- galeria ---------- */
  function initGallery(g) {
    if (g.__la) return;
    g.__la = true;
    var track = g.querySelector('[data-la-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-la-thumb]'));
    var count = g.querySelector('[data-la-count]');
    var prev = g.querySelector('[data-la-prev]');
    var next = g.querySelector('[data-la-next]');
    var index = -1;

    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function setActive(i) {
      if (i === index) return;
      index = i;
      thumbs.forEach(function (th, k) { th.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (count) count.textContent = i + 1 + ' / ' + slides.length;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
      var th = thumbs[i];
      if (th && th.parentElement) {
        var strip = th.parentElement;
        if (strip.scrollHeight > strip.clientHeight + 2) {
          strip.scrollTo({ top: th.offsetTop - strip.clientHeight / 2 + th.clientHeight / 2, behavior: 'smooth' });
        } else if (strip.scrollWidth > strip.clientWidth + 2) {
          strip.scrollTo({ left: th.offsetLeft - strip.clientWidth / 2 + th.clientWidth / 2, behavior: 'smooth' });
        }
      }
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { setActive(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
    }, { passive: true });
    thumbs.forEach(function (th, i) { th.addEventListener('click', function () { go(i); }); });
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    });
    var owner = g.closest('[data-la-buybox]');
    if (owner) {
      owner.addEventListener('la:media', function (e) {
        for (var i = 0; i < slides.length; i++) {
          if (String(slides[i].getAttribute('data-media-id')) === String(e.detail.id)) { go(i); break; }
        }
      });
    }
    setActive(0);
  }

  /* ---------- slider (karty, wideo, hero z autoodtwarzaniem) ---------- */
  function initSlider(s) {
    if (s.__la) return;
    s.__la = true;
    var track = s.querySelector('[data-la-slider-track]');
    if (!track) return;
    var prev = s.querySelector('[data-la-prev]');
    var next = s.querySelector('[data-la-next]');
    var dotsWrap = s.querySelector('[data-la-dots]');
    var dots = [];
    var autoplay = parseInt(s.getAttribute('data-la-autoplay') || '0', 10) || 0;
    var timerId = null;

    function items() { return Array.prototype.slice.call(track.children); }
    function step() {
      var first = items()[0];
      if (!first) return track.clientWidth || 1;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function pages() {
      var visible = Math.max(1, Math.round((track.clientWidth + 1) / step()));
      return Math.max(1, items().length - visible + 1);
    }
    function currentPage() { return Math.min(pages() - 1, Math.round(track.scrollLeft / step())); }
    function goTo(i) { track.scrollTo({ left: i * step(), behavior: reduceMotion ? 'auto' : 'smooth' }); }
    function buildDots() {
      if (!dotsWrap) return;
      var n = pages();
      if (dots.length === n) return;
      dotsWrap.innerHTML = '';
      dots = [];
      for (var i = 0; i < n; i++) {
        (function (k) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'la-dot';
          b.setAttribute('aria-label', 'Slajd ' + (k + 1) + ' z ' + n);
          b.addEventListener('click', function () { goTo(k); restart(); });
          dotsWrap.appendChild(b);
          dots.push(b);
        })(i);
      }
      dotsWrap.hidden = n < 2;
    }
    function sync() {
      var i = currentPage();
      var max = track.scrollWidth - track.clientWidth - 2;
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (prev) prev.disabled = !autoplay && track.scrollLeft <= 2;
      if (next) next.disabled = !autoplay && track.scrollLeft >= max;
      var bar = s.querySelector('.la-slider__bar');
      if (bar) bar.hidden = pages() < 2;
    }
    function advance(dir) {
      var n = pages();
      var i = currentPage() + dir;
      if (autoplay) i = (i + n) % n;
      goTo(Math.max(0, Math.min(n - 1, i)));
    }
    function stop() { clearInterval(timerId); timerId = null; }
    function restart() {
      if (!autoplay || reduceMotion) return;
      stop();
      timerId = setInterval(function () { if (!document.hidden) advance(1); }, autoplay * 1000);
    }

    if (prev) prev.addEventListener('click', function () { advance(-1); restart(); });
    if (next) next.addEventListener('click', function () { advance(1); restart(); });
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', function () {
      buildDots();
      goTo(currentPage());
      sync();
    });
    if (autoplay) {
      s.addEventListener('mouseenter', stop);
      s.addEventListener('mouseleave', restart);
      s.addEventListener('focusin', stop);
      track.addEventListener('touchstart', stop, { passive: true });
    }
    buildDots();
    sync();
    restart();
  }

  /* ---------- zakładki ---------- */
  function initTabs(wrap) {
    if (wrap.__la) return;
    wrap.__la = true;
    var btns = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
    var panels = btns.map(function (b) { return document.getElementById(b.getAttribute('aria-controls')); });
    function show(i, focus) {
      btns.forEach(function (b, k) {
        var on = k === i;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        if (panels[k]) panels[k].hidden = !on;
      });
      if (focus && btns[i]) btns[i].focus();
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { show(i); });
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        show((i + (e.key === 'ArrowRight' ? 1 : -1) + btns.length) % btns.length, true);
      });
    });
    wrap.__laShow = show;
    show(0);
  }

  /* ---------- karty wideo ---------- */
  function initVideoCard(card) {
    if (card.__la) return;
    card.__la = true;
    var btn = card.querySelector('[data-la-play]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var embed = card.getAttribute('data-embed');
      if (embed) {
        var iframe = document.createElement('iframe');
        iframe.src = embed;
        iframe.title = card.getAttribute('data-title') || 'Wideo';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.setAttribute('allowfullscreen', '');
        card.appendChild(iframe);
      } else {
        var video = card.querySelector('video');
        if (!video) return;
        video.controls = true;
        video.muted = false;
        var played = video.play();
        if (played && played.catch) played.catch(function () {});
      }
      card.classList.add('is-playing');
    });
  }

  /* ---------- „Dodaj do koszyka” na kartach ---------- */
  function initAddForm(form) {
    if (form.__la) return;
    form.__la = true;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var idEl = form.querySelector('input[name="id"]');
      if (!btn || !idEl || btn.disabled || btn.classList.contains('is-loading')) return;
      var label = btn.querySelector('[data-la-label]');
      var original = label ? label.textContent : '';
      btn.classList.add('is-loading');
      addToCart(parseInt(idEl.value, 10), 1, false)
        .then(function () { if (label) label.textContent = btn.getAttribute('data-t-added') || 'Dodano ✓'; })
        .catch(function (err) { if (label) label.textContent = (err && err.message) || 'Błąd'; })
        .then(function () {
          btn.classList.remove('is-loading');
          setTimeout(function () { if (label) label.textContent = original; }, 2200);
        });
    });
  }

  /* ---------- globalne kliknięcia: wybór rozmiaru, otwarcie zakładki ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var pick = e.target.closest('[data-la-pick]');
    if (pick) {
      var box = document.querySelector('[data-la-buybox]');
      if (box && typeof box.__laSelect === 'function' && box.__laSelect(parseInt(pick.getAttribute('data-la-pick'), 10))) {
        e.preventDefault();
        box.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
      return;
    }
    var tabLink = e.target.closest('[data-la-open-tab]');
    if (tabLink) {
      var tabs = document.querySelector('[data-la-tabs]');
      if (tabs && typeof tabs.__laShow === 'function') tabs.__laShow(parseInt(tabLink.getAttribute('data-la-open-tab'), 10) || 0);
    }
  });

  /* ---------- animacje wejścia ---------- */
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 })
    : null;
  function initReveal(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('.la-reveal:not(.is-in)'), function (el) {
      if (io) io.observe(el);
      else el.classList.add('is-in');
    });
  }

  function init(scope) {
    scope = scope || document;
    function all(selector, fn) { Array.prototype.forEach.call(scope.querySelectorAll(selector), fn); }
    all('[data-la-buybox]', initBuybox);
    all('[data-la-gallery]', initGallery);
    all('[data-la-slider]', initSlider);
    all('[data-la-tabs]', initTabs);
    all('[data-la-video-card]', initVideoCard);
    all('form[data-la-addform]', initAddForm);
    initReveal(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.LumiArt = { init: init, money: money, addToCart: addToCart };
})();